const API_BASE = import.meta.env.VITE_API_URL || '/api';

class ApiClient {
  private getHeaders(token: string | null): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  }

  private getToken(): string | null {
    return sessionStorage.getItem('id_token');
  }

  async get(path: string, token?: string | null): Promise<any> {
    const t = token ?? this.getToken();
    const response = await fetch(`${API_BASE}${path}`, {
      method: 'GET',
      headers: this.getHeaders(t),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `HTTP ${response.status}`);
    }
    return response.json();
  }

  async post(path: string, body: any, token?: string | null): Promise<any> {
    const t = token ?? this.getToken();
    const response = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: this.getHeaders(t),
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `HTTP ${response.status}`);
    }
    return response.json();
  }

  async put(path: string, body: any, token?: string | null): Promise<any> {
    const t = token ?? this.getToken();
    const response = await fetch(`${API_BASE}${path}`, {
      method: 'PUT',
      headers: this.getHeaders(t),
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `HTTP ${response.status}`);
    }
    return response.json();
  }

  async delete(path: string, body?: any, token?: string | null): Promise<any> {
    const t = token ?? this.getToken();
    const response = await fetch(`${API_BASE}${path}`, {
      method: 'DELETE',
      headers: this.getHeaders(t),
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `HTTP ${response.status}`);
    }
    return response.json();
  }

  async uploadImage(file: File, token?: string | null): Promise<string> {
    const t = token ?? this.getToken();
    // 1. Get presigned URL
    const { uploadUrl, imageUrl } = await this.post('/images/upload', {
      filename: file.name,
      contentType: file.type,
    }, t);

    // 2. Upload directly to S3
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });
    if (!uploadResponse.ok) {
      throw new Error(`Image upload failed: HTTP ${uploadResponse.status}`);
    }

    return imageUrl;
  }
}

export const apiClient = new ApiClient();
